import { AgHomeConfigSettings } from '@mri-platform/ag-shared/services';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const envSettings: any = {};

const CONFIG_CACHE_KEY = 'ag-home:last-known-config';

async function fetchConfig(): Promise<AgHomeConfigSettings> {
  try {
    const response = await fetch('/api/config');
    if (!response.ok) {
      throw new Error('Failed to fetch configuration');
    }
    const config: AgHomeConfigSettings = await response.json();
    try {
      localStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify(config));
    } catch {
      // storage full/unavailable - non-fatal
    }
    return config;
  } catch (error) {
    const cached = localStorage.getItem(CONFIG_CACHE_KEY);
    if (cached) {
      console.warn('Config fetch failed; using last-known-good config from localStorage', error);
      return JSON.parse(cached) as AgHomeConfigSettings;
    }
    throw error;
  }
}

function ifUnassigned(value: string | null, defaultValue: string): string {
  const assigned = value != null && value.indexOf('#{') === -1;
  return assigned ? value : defaultValue;
}

function parseBool(value: string | null, defaultValue: boolean): boolean {
  if (value == null) {
    return defaultValue;
  }
  return value.toString().toLowerCase() === 'true';
}

export async function GetConfig() {
  const config: AgHomeConfigSettings = await fetchConfig();

  envSettings.api = envSettings.api ?? {};
  envSettings.api.baseUrl = ifUnassigned(config.AppGateway.BaseApiUrl, '');
  envSettings.api.path = 'api/v1';
  envSettings.api.name = 'AG Home';

  envSettings.agWidget = envSettings.agWidget ?? {};
  envSettings.agWidget.baseApiUrl = ifUnassigned(config.AppGateway.BaseApiUrl, '');
  envSettings.agWidget.enableAppInsights = parseBool(ifUnassigned(config.AppGateway.EnableAppInsights, 'false'), false);

  envSettings.agShared = envSettings.agShared ?? {};
  envSettings.agShared.trainingAcademyUrl = ifUnassigned(config.AppGateway.TrainingAcademyUrl, '');
  envSettings.agShared.version = ifUnassigned(config.AppGateway.Version, '');
  envSettings.agShared.region = ifUnassigned(config.Region, '');
  envSettings.agShared.version = 'v3';

  envSettings.cspConfig = envSettings.cspConfig ?? {};
  envSettings.cspConfig.mriOktaDomain = ifUnassigned(config.Csp.MriOktaDomain, '');
  envSettings.cspConfig.agApi = ifUnassigned(config.AppGateway.BaseApiUrl, '');
  envSettings.cspConfig.imageCdns = ifUnassigned(config.Csp.ImageCdns, '');
  envSettings.cspConfig.pendoDomains = ifUnassigned(config.Csp.PendoDomains, '');
  envSettings.cspConfig.appInsights = ifUnassigned(config.Csp.AppInsightsWhitelist, '');
  envSettings.cspConfig.signalR = ifUnassigned(config.Csp.SignalR, '');

  const loginHint = new URLSearchParams(window.location.search).get('login_hint');
  envSettings.auth = envSettings.auth ?? {};
  envSettings.auth.clientId = ifUnassigned(config.Auth.ClientId, '');
  envSettings.auth.issuer = ifUnassigned(config.Auth.Issuer, '');
  envSettings.auth.proxyBaseUrl = ifUnassigned(config.Auth.ProxyBaseUrl, '');
  envSettings.auth.postLogoutRedirectUri = ifUnassigned(config.Auth.PostLogoutRedirectUri, '');
  envSettings.auth.scope = 'openid profile email mri:ag:api offline_access';
  envSettings.auth.postLogoutRedirectUriResponseMode = 'form_post';
  envSettings.auth.appUserInfoEndpoint = 'api/v3/user/info';
  envSettings.auth.customQueryParams = {
    ...(loginHint ? { login_hint: loginHint } : {})
  };

  envSettings.appInsights = envSettings.appInsights ?? {};
  envSettings.appInsights.cloudRoleName = 'AG Home';
  envSettings.appInsights.enableTelemetry = parseBool(ifUnassigned(config.AppInsights.EnableTelemetry, 'false'), false);
  envSettings.appInsights.instrumentationKey = ifUnassigned(config.AppInsights.InstrumentationKey, '');
  envSettings.appInsights.samplingPercentage = +ifUnassigned(config.AppInsights.SamplingPercentage, '100');

  envSettings.adminUrl = ifUnassigned(config.AdminUrl, '');

  envSettings.pendo = envSettings.pendo ?? {};
  envSettings.pendo.apiKey = ifUnassigned(config.Pendo.ApiKey, '');
  envSettings.pendo.enabled = parseBool(ifUnassigned(config.Pendo.Enabled, 'false'), false);

  envSettings.featureFlags = envSettings.featureFlags ?? {};
  envSettings.featureFlags.path = 'admin/featureflags';

  window.__settings = envSettings;
}
